import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery, clientGraphQLAuthMutation } from "../../../../core/data/GraphQLApi";
import { clientPOST } from "../../../../core/data/RestApi";
import { endpoints } from "../../../../core/defaultValues";
import { resetALL } from "../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../core/logManager";
import { isJson } from "../../../../core/data/Helpers";
//actions
import { logout, setPermissionToMigrateUser } from "Redux/actions";
import { setCookie, eraseCookie } from "Core/views/login/helper";

const INIT_STATE = {
  loading: false,
  loadingSM: false,
  cognitoValues: null,
  error: null,
  showConfirm: false,
  token: null,
  showPassword: false,
  loadingLoginPage: false,
  loginPage: null,
  session: null,
  username: null,
  termAndConditionData: {}
};

const route = "core/views/login/redux/slice";

export const checkLoginUserByCode = createAsyncThunk(
  "core/views/login/checkLoginUserByCode",
  async (payload, { dispatch, rejectWithValue }) => {
    const domainUri =
      window.location.hostname === "localhost"
        ? `http://localhost:40000`
        : `https://${window.location.hostname}`;
    const { code, navigate } = payload;
    try {
      let headers = {
        "Content-Type": "application/x-www-form-urlencoded"
      };
      const data = await clientPOST(
        "",
        {
          code,
          client_id: `${endpoints.COGNITO_CLIENT_ID}`,
          grant_type: "authorization_code",
          redirect_uri: `${domainUri}/login-social-media`
        },
        `${endpoints.COGNITO_DOMAIN_USER_POOL_EXTERNAL}oauth2/token`,
        headers,
        true
      );
      if (data) {
        localStorage.setItem("AccessToken", data.access_token);
        localStorage.setItem("RefreshToken", data.refresh_token);
        localStorage.setItem("IdToken", data.id_token);
        setCookie("GPSTSharedOAUTHToken", data.id_token, 1);
        //remove local preferences
        localStorage.removeItem("preferencesUser");
        localStorage.removeItem("preferencesCompany");
        localStorage.removeItem("preferencesOther");
        const dataToLoginPHP = await clientQuery(
          `{
            User: getLoginInformation{
            username
            }
        }`,
          {},
          endpoints.GRAPHQL_GENERAL
        );
        if (dataToLoginPHP?.User) {
          const username = dataToLoginPHP?.User?.username;
          localStorage.setItem("username", username);
          dispatch(loginResult({ cognitoValues: data, showConfirm: false }));
          navigate("/");
        }
      }
    } catch (exc) {
      // catch throw
      localStorage.removeItem("AccessToken");
      localStorage.removeItem("RefreshToken");
      localStorage.removeItem("IdToken");
      localStorage.removeItem("username");
      eraseCookie("GPSTSharedOAUTHToken");
      const domainUri =
        window.location.hostname === "localhost"
          ? `http://localhost:40000`
          : `https://${window.location.hostname}`;
      window.location = `${endpoints.COGNITO_DOMAIN_USER_POOL_EXTERNAL}logout?client_id=${endpoints.COGNITO_CLIENT_ID}&logout_uri=${domainUri}/login`;
      ExceptionManager(exc, route, "Error Login with social media");
      return rejectWithValue("Error Login with social media");
    }
  }
);

export const checkMigrate = createAsyncThunk(
  "core/views/login/checkMigrate",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const { username, navigate } = payload;
      const data = await clientGraphQLAuthMutation(
        `
                  mutation ($username: String!){
                    result: checkMigrateUser(username: $username) {
                      migrated
                      username
                      email
                      companyId
                    }
                  }
              `,
        {
          username
        }
      );
      if (data.error) {
        ExceptionManager(exc, "Core/views/login/redux", "checkMigrate");
        return rejectWithValue("Username or email entered is incorrect.");
      }
      dispatch(checkMigrateResult(true));
      if (data.result?.migrated) {
        dispatch(setPermissionToMigrateUser(true));
        dispatch(loginResult());
        navigate(
          `/migrateUser/${data.result.username}/${
            data.result.email ? data.result.email + "/" : ""
          }${data.result.companyId || ""}`
        );
      }
    } catch (exc) {
      // catch throw
      ExceptionManager(exc, "Core/views/login/redux", "checkMigrate");
      dispatch(loginResult({ cognitoValues: null, showConfirm: false, error: exc }));
      return rejectWithValue(exc);
    }
  }
);

export const login = createAsyncThunk(
  "core/views/login/login",
  async ({ username, password, navigate }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(logout());
      const data = await clientGraphQLAuthMutation(
        `
              mutation ($username: String!, $password: String!){
                    result: signIn(username:$username, password:$password){
                        authenticationResult{
                            AccessToken
                            ExpiresIn
                            IdToken
                            RefreshToken
                            ChallengeName
                            Session
                        },
                        emailVerified,
                        username
                    }
                }
          `,
        { username, password }
      );
      if (data && data.result && data.result.authenticationResult) {
        const { emailVerified, authenticationResult, username } = data.result;
        if (!emailVerified) {
          dispatch(loginResult({ cognitoValues: authenticationResult, showConfirm: true }));
        } else if (authenticationResult.ChallengeName === "NEW_PASSWORD_REQUIRED") {
          let values = {
            username,
            session: authenticationResult.Session
          };
          dispatch(newPasswordRequiredResult(values));
          navigate("/forceChangePassword");
        } else {
          localStorage.removeItem("sm");
          localStorage.setItem("AccessToken", authenticationResult.AccessToken);
          localStorage.setItem("RefreshToken", authenticationResult.RefreshToken);
          localStorage.setItem("IdToken", authenticationResult.IdToken);
          setCookie("GPSTSharedOAUTHToken", authenticationResult.IdToken, 1);
          localStorage.setItem("username", data.result.username);

          //remove local preferences
          localStorage.removeItem("preferencesUser");
          localStorage.removeItem("preferencesCompany");
          localStorage.removeItem("preferencesOther");

          dispatch(loginResult({ cognitoValues: authenticationResult, showConfirm: false }));
          navigate("/");
        }
      }
    } catch (exc) {
      // catch throw
      ExceptionManager(exc, route, "login");
      dispatch(loginResult({ cognitoValues: null, showConfirm: false, error: exc }));
      navigate("/login");
      return rejectWithValue(exc);
    }
  }
);

export const termsAndCondition = createAsyncThunk(
  "core/views/login/termsAndCondition",
  async ({ username, password, navigate }, { dispatch, rejectWithValue }) => {
    try {
      const data = await clientGraphQLAuthMutation(
        `
               mutation ($username: String!, $password: String!){
                    result: acceptedTermAndCondition(username:$username, password:$password){
                        authenticationResult{
                            AccessToken
                            ExpiresIn
                            IdToken
                            RefreshToken
                            ChallengeName
                            Session
                        },
                        emailVerified,
                        username
                    }
                }
            `,
        { username, password }
      );
      if (data && data.result && data.result.authenticationResult) {
        const { authenticationResult } = data.result;
        localStorage.removeItem("sm");
        localStorage.setItem("AccessToken", authenticationResult.AccessToken);
        localStorage.setItem("RefreshToken", authenticationResult.RefreshToken);
        localStorage.setItem("IdToken", authenticationResult.IdToken);
        setCookie("GPSTSharedOAUTHToken", authenticationResult.IdToken, 1);
        localStorage.setItem("username", data.result.username);

        //remove local preferences
        localStorage.removeItem("preferencesUser");
        localStorage.removeItem("preferencesCompany");
        localStorage.removeItem("preferencesOther");

        dispatch(loginResult({ cognitoValues: authenticationResult, showConfirm: false }));
        navigate("/");
      }
    } catch (exc) {
      // catch throw
      ExceptionManager(exc, route, "termsAndCondition");
      dispatch(loginResult({ cognitoValues: null, showConfirm: false, error: exc }));
      navigate("/login");
      return rejectWithValue(exc);
    }
  }
);

export const loginWithPM = createAsyncThunk(
  "core/views/login/loginWithPM",
  async ({ username, token, navigate }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(logout());
      const data = await clientGraphQLAuthMutation(
        `
            mutation signInWithPM ($token: String!, $username: String!) {
                result: signInWithPM (token: $token, username: $username) {
                    authenticationResult{
                        AccessToken
                        ExpiresIn
                        IdToken
                        RefreshToken
                    }
                    emailVerified
                    username
                }
            }
        `,
        { username, token }
      );
      if (data && data.result && data.result.authenticationResult) {
        const { authenticationResult, username } = data.result;

        localStorage.setItem("AccessToken", authenticationResult.AccessToken);
        localStorage.setItem("RefreshToken", authenticationResult.RefreshToken);
        localStorage.setItem("IdToken", authenticationResult.IdToken);
        setCookie("GPSTSharedOAUTHToken", authenticationResult.IdToken, 1);
        localStorage.setItem("username", username);
        localStorage.setItem("sm", true);
        //remove local preferences
        localStorage.removeItem("preferencesUser");
        localStorage.removeItem("preferencesCompany");
        localStorage.removeItem("preferencesOther");

        dispatch(loginResult({ cognitoValues: authenticationResult, showConfirm: false }));
        navigate("/app");
      }
    } catch (exc) {
      navigate("/login");
      // catch throw
      ExceptionManager(exc, route, "loginWithPM");
      dispatch(
        loginResult({
          cognitoValues: null,
          showConfirm: false,
          error: "Incorrect Username or Password"
        })
      );
      return rejectWithValue("Incorrect Username or Password");
    }
  }
);

export const loginConfirm = createAsyncThunk(
  "core/views/login/loginConfirm",
  async ({ username, code, cognitoValues, navigate, messages }, { dispatch, rejectWithValue }) => {
    try {
      const data = await clientGraphQLAuthMutation(
        `
            mutation ($accessToken: String!, $code: String!) {
                result: verifyEmail(accessToken: $accessToken, code: $code)
            }
          `,
        { accessToken: cognitoValues.AccessToken, code: code.toString() }
      );
      if (data && data.result) {
        localStorage.removeItem("sm");
        localStorage.setItem("AccessToken", cognitoValues.AccessToken);
        localStorage.setItem("RefreshToken", cognitoValues.RefreshToken);
        localStorage.setItem("IdToken", cognitoValues.IdToken);
        setCookie("GPSTSharedOAUTHToken", cognitoValues.IdToken, 1);
        localStorage.setItem("username", username);
        //remove local preferences
        localStorage.removeItem("preferencesUser");
        localStorage.removeItem("preferencesCompany");
        localStorage.removeItem("preferencesOther");

        dispatch(loginConfirmResult());
        navigate("/");
      } else {
        dispatch(
          loginConfirmResult({
            error:
              data.errorMessage ||
              data?.errors[0]?.message ||
              messages["migrateUser_verifyCodeError"]
          })
        );
      }
      return {
        error:
          data.errorMessage || data?.errors[0]?.message || messages["migrateUser_verifyCodeError"]
      };
    } catch (exc) {
      // catch throw
      ExceptionManager(exc, route, "loginConfirm");
      dispatch(loginConfirmResult({ error: exc }));
      return rejectWithValue(exc);
    }
  }
);

export const getLoginPage = createAsyncThunk(
  "core/views/login/getLoginPage",
  async ({ fileKey, preview, language, navigate }, { rejectWithValue }) => {
    try {
      const query = `query getLoginPage ($fileKey: String!, $preview: Boolean!, $language: String!) {
            page: getLoginPage (fileKey: $fileKey, preview: $preview, language: $language)
        }`;
      const response = await clientQuery(
        query,
        {
          fileKey,
          preview,
          language
        },
        endpoints.GRAPHQL_GENERAL,
        {
          "x-api-key": endpoints.PUBLIC_API_KEY
        }
      );
      if (!response || !response?.page || response?.page === "<p></p>") {
        // throw Error("Login page content not found");
        ExceptionManager(exc, route, "getLoginPage");
        return rejectWithValue(exc);
      }
      navigate("/login", { replace: true });
      return response.page;
    } catch (exc) {
      // catch throw
      ExceptionManager(exc, route, "getLoginPage");
      return rejectWithValue(exc);
    }
  }
);

const loginRedux = createSlice({
  name: "core/views/login",
  initialState: INIT_STATE,
  reducers: {
    loginConfirmClose: () => {
      return { ...INIT_STATE };
    },
    loginResult: (state, action) => {
      state.loading = false;
      state.loadingSM = false;
      if (!action.payload) {
        state.cognitoValues = INIT_STATE.cognitoValues;
        state.showConfirm = INIT_STATE.showConfirm;
        state.error = INIT_STATE.error;
        state.token = INIT_STATE.token;
        return;
      }
      state.cognitoValues = action.payload.cognitoValues;
      state.showConfirm = action.payload.showConfirm;
      state.error = action.payload.error;
      state.token = action.payload.token;
    },
    getLoginPageResult: (state, action) => {
      state.loginPage = action.payload.response;
    },
    loginConfirmResult: (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    },
    checkMigrateResult: (state, action) => {
      state.showPassword = action.payload;
      state.loading = false;
    },
    newPasswordRequiredResult: (state, action) => {
      state.session = action.payload.session;
      state.username = action.payload.username;
    },
    updateTermsAndCondition: (state, action) => {
      state.termAndConditionData = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    // checkLoginUserByCode
    builder.addCase(checkLoginUserByCode.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(checkLoginUserByCode.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(checkLoginUserByCode.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // checkMigrate
    builder.addCase(checkMigrate.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(checkMigrate.fulfilled, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(checkMigrate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // login
    builder.addCase(login.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(login.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // termsAndCondition
    builder.addCase(termsAndCondition.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(termsAndCondition.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(termsAndCondition.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // loginWithPM
    builder.addCase(loginWithPM.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(loginWithPM.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(loginWithPM.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // loginConfirm
    builder.addCase(loginConfirm.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(loginConfirm.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(loginConfirm.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // getLoginPage
    builder.addCase(getLoginPage.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getLoginPage.fulfilled, (state, action) => {
      state.loading = false;
      state.loginPage = action.payload.response;
    });
    builder.addCase(getLoginPage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = loginRedux;

// Extract and export each action creator by name
export const {
  loginConfirmClose,
  loginResult,
  loginConfirmResult,
  getLoginPageResult,
  checkMigrateResult,
  newPasswordRequiredResult,
  updateTermsAndCondition
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
